module.exports = __webpack_public_path__ + "static/LucasPope6-d839cda543a5fc02d886df76e502eef6.png";